import React, { useState, useEffect } from "react";
import LoginForm from "../../components/Forms/Signup/SignInForm";
import SignupForm from "../../components/Forms/Signup/SignupForm";
import ForgotPasswordForm from "../../components/Forms/Signup/ForgotPasswordForm";
import "./custom.css";

const LoginPage: React.FC = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [forgotPassword, setForgotPassword] = useState(false);

  const handleSwitch = () => {
    setIsLogin(!isLogin);
    setForgotPassword(false);
  };

  useEffect(() => {
    document.title = "MamFam Login";
  }, []);

  return (
    <div className="login-page-container">
      <div className="login-page-card">
        <div className="card-body text-center">
          <h2 className="login-page-title">
            {forgotPassword ? "Forgot Password" : isLogin ? "Login" : "Sign Up"}
          </h2>

          {forgotPassword ? (
            <ForgotPasswordForm setForgotPassword={setForgotPassword} />
          ) : isLogin ? (
            <LoginForm
              setIsLogin={setIsLogin}
              setForgotPassword={setForgotPassword}
            />
          ) : (
            <SignupForm setIsLogin={setIsLogin} />
          )}

          {!forgotPassword && (
            <p className="mt-3">
              <a
                href="#"
                onClick={() => setForgotPassword(true)}
                className="login-page-switch-link"
              >
                Forgot Password?
              </a>
            </p>
          )}

          <p className="mt-3">
            {isLogin ? "Don't have an account?" : "Already have an account?"}{" "}
            <a
              href="#"
              onClick={handleSwitch}
              className="login-page-switch-link"
            >
              {isLogin ? "Sign Up" : "Login"}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
